import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import axios from 'axios';
import { IAuthState } from '../auth/types';
import { API_BASEURL } from '../common/constants';
import { API_TAG_TYPES } from '../common/types';

interface IHealthCheckResponse {
  health: boolean;
  dbHealth: boolean;
  versions: {
    app_version: string;
    android_version: string;
    ios_version: string;
    commit_hash: string;
  };
}

export const superAppApi = createApi({
  reducerPath: 'superAppApi',
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASEURL,
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as { superAppAuth: IAuthState };
      const accessToken = state.superAppAuth.auth?.access_token;

      return new Headers({
        ...headers,
        ...(accessToken
          ? {
              Authorization: `Bearer ${accessToken}`,
            }
          : {}),
        'Content-Type': 'application/json',
        portal: 'admin-portal',
      });
    },
  }),
  tagTypes: API_TAG_TYPES,
  endpoints: (build) => ({
    getHealthCheck: build.query<IHealthCheckResponse, void>({
      query: () => ({
        url: '/healthcheck',
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetHealthCheckQuery } = superAppApi;

export const axiosApi = axios.create({
  baseURL: API_BASEURL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    portal: 'admin-portal',
  },
});
